import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("summary", null, [
  /*#__PURE__*/_createElementVNode("i", null, "calendar_month"),
  /*#__PURE__*/_createElementVNode("span", null, "Kalender-Abo")
], -1)
const _hoisted_2 = { class: "grid medium-space" }
const _hoisted_3 = { class: "s12 m9 l6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "Alle Termine:", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", null, "content_copy", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "kopieren", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "s12 m9 l6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", null, "Nur meine Termine:", -1)
const _hoisted_11 = { class: "field label" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", null, "content_copy", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "kopieren", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", null, "ACHTUNG: Diese Links nicht direkt im Browser verwenden, sonst wird nur der momentane Stand heruntergeladen, der sich dann nicht mehr aktualisiert. Stattdessen die Funktion \"Kalender-Abonnement\" ihre Kalenders verwenden, um den Kalender als Abo einzubinden.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_input = _resolveComponent("tickets-input")!

  return (_openBlock(), _createElementBlock("details", null, [
    _hoisted_1,
    _createElementVNode("article", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", {
            class: "hand",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copy($setup.url)))
          }, [
            _createElementVNode("span", null, _toDisplayString($setup.url))
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copy($setup.url))),
              disabled: $setup.v$.$errors.length > 0
            }, _hoisted_8, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, [
            _createElementVNode("span", null, _toDisplayString($setup.customUrl.replace('+', '%2b')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_tickets_input, {
              label: "Bitte Telefonnummer eingeben",
              cy: "phoneinput",
              modelValue: $setup.reg.phoneinput,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.reg.phoneinput) = $event)),
              val: $setup.v$.phoneinput,
              onBlurred: $setup.format
            }, null, 8, ["modelValue", "val"])
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.copy($setup.customUrl))),
              disabled: $setup.v$.$silentErrors.length > 0
            }, _hoisted_15, 8, _hoisted_12)
          ])
        ])
      ]),
      _hoisted_16
    ])
  ]))
}